import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


export const CguModal = ({ onAccept }) => {
  return (
    <Modal
      isOpen
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="custom-cgu-modal-content"
      modalClassName="custom-cgu-modal-wrapper">
      <ModalHeader
        style={{
          fontWeight: 'bold',
          fontSize: '2rem',
        }}
      >
        <h4>Conditions Générales d'Utilisation</h4>
      </ModalHeader>
      <ModalBody
        style={{
          maxHeight: '300px',
          overflowY: 'auto',
          padding: '1.5rem',
          fontSize: '0.8rem',
          lineHeight: '1.6',
          color: '#333',
        }}
      >
        <h6 style={{color: '#4F81BE'}}>Préambule</h6>
        <p>
          ENGIE a mis en place une Plateforme à destination de ses Clients qui souhaitent accéder à différentes Données et/ou Services complémentaires définis ci-après, à partir d'un espace personnalisé du site internet{' '}
          <a
            href="https://strategie.entreprises-collectivites.engie.fr"
            target="_blank"
            rel="noopener noreferrer"
            css={{
              color: '#0072BC',
              fontWeight: 'bold',
              textDecoration: 'underline',
            }}
          >
            https://strategie.entreprises-collectivites.engie.fr
          </a>.
        </p>
        <h6 style={{color: '#4F81BE'}}>1. Définitions</h6>
        <p>
          Les termes ou expressions, lorsqu'ils sont employés avec une majuscule, auront la signification suivante :
        </p>
        <ul style={{ listStyleType: 'disc' }} >
          <li>
            Client : tout Client personne physique ou morale agissant à des fins entrant dans le cadre de son activité commerciale, industrielle, artisanale, libérale ou agricole, ainsi que tout syndicat de copropriétaires, et titulaire d'un Contrat de vente d'énergie conclu avec ENGIE pour le(s) Point(s) de Livraison et/ou le(s) Point(s) de Comptage et d'Estimation auquel s'applique la Plateforme ;
          </li>
          <li>
            Contrat de vente d'énergie : contrat de vente de gaz naturel ou d'électricité conclu entre le Client et ENGIE ;
          </li>
          <li>
            Données : inclut certaines données de prix, ainsi que certaines informations contenues dans le Contrat de vente d'énergie que le Client a souscrit auprès d'ENGIE ;
          </li>
          <li>
            Identifiant : adresse e-mail de l'Utilisateur ;
          </li>
          <li>
            Interlocuteur ENGIE: interlocuteur ENGIE dont les coordonnées figurent sur la facture d'énergie du Client ;
          </li>
          <li>
            Plateforme : outil accessible par internet à destination des Clients qui souhaitent accéder à différentes Données et/ou Services complémentaires définis ci-après, à partir d'un espace personnalisé du site internet https://strategie.entreprises-collectivites.engie.fr ;
          </li>
          <li>
            Point de Livraison ou Point de Comptage et d'Estimation : point géographique où respectivement le gaz naturel ou l'électricité est livré(e) au Client en vertu de son Contrat de vente d'énergie ;
          </li>
          <li>
            Services complémentaires : services inclus dans la Plateforme permettant au Client de modéliser et piloter sa stratégie d'achat dans le cadre de ses Contrats de vente d'énergie ;
          </li>
          <li>
            Utilisateur(s) : personne(s) désignée(s) par le Client, habilitée(s) à accéder à la Plateforme. Il(s) bénéficie(nt) de tout ou partie des fonctions et services de la Plateforme selon les habilitations qui auront été définies pour lui par ENGIE.
          </li>
        </ul>
        <h6 style={{color: '#4F81BE'}}>2. Objet</h6>
        <p>
          Les présentes conditions générales, ci-après « Conditions Générales d'Utilisation» ont pour objet de définir les conditions d'utilisation de la Plateforme.
        </p>
        <p>
          La Plateforme est disponible à certains Clients dont le(s) Point(s) de Livraison et/ou le(s) Point(s) de Comptage et d'Estimation sont situés en France Métropolitaine.
        </p>
        <p>
          La Plateforme permet au Client (via l'Utilisateur) de consulter ses Données relatives aux Contrats de vente d'énergie conclus avec ENGIE.
        </p>
        <p>
          Les Données sont mises à jour en fonction de l'évolution des prix des marchés de l'énergie ainsi que des fixations réalisées par le Client au titre des Contrats de ventes d'énergie concernés.
        </p>
        <p>
          Les Données communiquées dans le cadre de la Plateforme sont fournies à titre purement indicatif et n'ont aucune valeur contractuelle.
        </p>
        <p>
          En cas de différence ou contradiction entre les Données disponibles sur la Plateforme et celles figurant dans les Contrats de vente d'énergie, les données figurant dans les Contrats de vente d'énergie prévalent. De même, en cas de différence ou contradiction entre les Données disponibles sur la Plateforme et celles figurant sur les factures reçues par le Client, les données figurant sur les factures prévalent.
        </p>
        <p>
          Enfin, la Plateforme permet au Client (via l'Utilisateur) de modéliser et piloter sa stratégie d'achat dans le cadre de ses Contrats de vente d'énergie conclus avec ENGIE.
        </p>
        <h6 style={{color: '#4F81BE'}}>3. Modalités d'accès à la Plateforme</h6>
        <p>
          L'accès et l'utilisation de la Plateforme sont soumis à l'acceptation préalable et au respect des présentes Conditions Générales d'Utilisation.
        </p>
        <p>
          Le Client, par l'intermédiaire de l'Utilisateur, devra exprimer sa volonté d'accéder et de bénéficier de la Plateforme en faisant dérouler les CGU et en cochant la case « J'ai pris connaissance des Conditions Générales d'Utilisation et je les accepte » puis par un clic sur le bouton « Valider ». Par cette double expression du consentement, le Client déclare avoir pris connaissance et accepter les présentes Conditions Générales d'Utilisation.
        </p>
        <p>
          Le Client reçoit par courrier électronique (à l'adresse électronique définie comme son Identifiant), une confirmation de la création de son espace personnel sur la Plateforme.
        </p>
        <p>
          Le Client s'engage à informer ENGIE, dans les plus brefs délais, de toute modification concernant sa situation en adressant un courrier ou un e-mail à l'Interlocuteur ENGIE dont les coordonnées sont mentionnées sur sa facture d'énergie.
        </p>
        <p>
          L'Utilisateur, accède à la Plateforme grâce à son Identifiant et son mot de passe unique et personnel.
        </p>
        <p>
          L'Utilisateur peut modifier à tout moment son Identifiant et/ou son mot de passe par une double saisie dans la rubrique de la Plateforme prévue à cet effet.
        </p>
        <p>
          En cas de perte ou d'oubli de son mot de passe, l'Utilisateur doit utiliser le lien « Mot de passe oublié » pour définir un nouveau mot de passe.
        </p>
        <p>
          L'accès à la Plateforme peut être retiré à un Utilisateur par le Client à tout moment. Il appartient au Client de gérer les habilitations accordées aux différents Utilisateurs de la Plateforme ainsi que les retraits d'accès. En cas de retrait d'accès à un Utilisateur, le Client s'engage à informer immédiatement son Interlocuteur ENGIE.
        </p>
        <p>
          Le Client s'engage à informer immédiatement son Interlocuteur ENGIE de toute utilisation non autorisée de son identifiant sur la Plateforme, de son mot de passe, et plus généralement de toute atteinte à la sécurité dont il aurait connaissance.
        </p>
        <p>
          En cas d'opération de maintenance de la Plateforme ou en cas d'incident d'exploitation. Le Client et/ou l'Utilisateur sera informé par écrit de la non-disponibilité de la Plateforme. Le Client et/ou l'Utilisateur doit alors renouveler sa consultation ultérieurement.
        </p>
        <h6 style={{color: '#4F81BE'}}>4. Périmètre de la Plateforme</h6>
        <p>
          Seuls les contrats de vente d'énergie conclus entre le Client et ENGIE peuvent être intégrés dans la Plateforme.
        </p>
        <p>
          La liste des Contrats de vente d'énergie figurant sur la Plateforme est établie conjointement par le Client et ENGIE.
        </p>
        <p>
          Le Client s'engage à informer son Interlocuteur ENGIE de tout changement juridique intervenu dans le(s) Contrat(s) de vente d'énergie ou de toute modification concernant sa situation.
        </p>
        <p>
          L'accès à la Plateforme est modifié, par ENGIE, de plein droit et sans formalité en cas de résiliation, pour quelle que cause que ce soit, d'un ou plusieurs Contrats de vente d'énergie, ou de toute opération juridique affectant l'un ou plusieurs des Contrats de vente d'énergie précités (par exemple, cession du Contrat de vente d'énergie à un tiers, cession du fonds de commerce, mise en location-gérance, fusion, absorption, scission, etc).
        </p>
        <h6 style={{color: '#4F81BE'}}>5. Propriété intellectuelle</h6>
        <p>
          Les différents logos ou marques qui apparaissent sur la Plateforme, ne peuvent être utilisés sans l'autorisation écrite et préalable d'ENGIE.
        </p>
        <p>
          La Plateforme appartient à ELENEO, prestataire de ENGIE. La Plateforme constitue une œuvre protégée par la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Par conséquent, sauf autorisation écrite et préalable de ENGIE, toute copie, reproduction, diffusion intégrale ou partielle du contenu de ce site, quel que soit le procédé, est interdite, à l'exception d'une copie ou reproduction réservée à l'usage exclusivement privé du copiste. Il en est de même pour les différents logos ou marques qui apparaissent sur la Plateforme, lesquels ne peuvent être utilisés sans l'autorisation écrite et préalable d'ENGIE.
        </p>
        <h6 style={{color: '#4F81BE'}}>6. Données Personnelles</h6>
        <p>
          Dans le cadre de la mise à disposition à ses Clients de la Plateforme, ENGIE agit en qualité de responsable de traitement, dans le respect de la réglementation relative à la protection des données personnelles.
        </p>
        <p>
          Les traitements de données sont réalisés sur la base de l'exécution des Contrats de ventes d'énergie, et ont pour finalité la mise à disposition de la Plateforme pour :
        </p>
        <p>
          - L'accès à la Plateforme et aux Données et Services complémentaires
        </p>
        <p>
          - La gestion des droits d'accès des Utilisateurs ;
        </p>
        <p>
          Dans le cadre des Modalités d'accès à la Plateforme telles que décrites à l'article 3, les données personnelles des personnes physiques désignées Utilisateur(s) peuvent être communiquées par un représentant du Client distinct de la personne désignée. Le cas échéant, le Client s'engage à avoir préalablement informé la personne désignée de la transmission de ses données personnelles à ENGIE pour les finalités prévues au présent article avant communication à ENGIE des données personnelles la concernant. Il s'engage également à avoir fait part à la personne désignée de ses droits relatifs aux données personnelles détenues par ENGIE.
        </p>
        <p>
          Dans le cadre de la mise en œuvre du traitement de données, les données du Client ne sont accessibles qu'aux personnes habilitées et aux destinataires légitimes. Elles sont stockées de préférence en France ou au sein de l'Union Européenne. Dans le cas d'un éventuel transfert hors l'Union Européenne, ENGIE s'assure de mettre en place tous les outils et les mesures nécessaires afin que le transfert soit réalisé de manière sécurisée et dans le respect des lois et des règlementations relatives à la protection des données personnelles.
        </p>
        <p>
          Conformément à la règlementation applicable, le Client dispose d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation et de portabilité de ses données. Il peut exercer l'ensemble de ces droits en s'adressant à l'adresse suivante : donneespersonnelles-entreprisesetcollectivites@engie.com. Le Client dispose également de la possibilité d'introduire une réclamation auprès de la CNIL et a en outre la possibilité de s'adresser au délégué à la protection des données d'ENGIE : https://engiegbs.service-now.com/gdpr_portal?id=gdpr_home
        </p>
        <p>
          Les informations supplémentaires sur les traitements de données mis en œuvre par ENGIE sont disponibles sur la charte de protection des données à caractère personnel, consultable à l'adresse suivante: https://entreprises-collectivites.engie.fr/donnees-personnelles
        </p>
        <h6 style={{color: '#4F81BE'}}>7. Durée</h6>
        <p>
          Le Client a accès à la Plateforme dès son acceptation des Conditions Générales d'Utilisation et pour une durée égale à la période contractuelle de son Contrat de vente d'énergie.
        </p>
        <h6 style={{color: '#4F81BE'}}>8. Responsabilité</h6>
        <p>
          ENGIE ne saurait être tenue pour responsable des retards ou des impossibilités de remplir ses obligations contractuelles survenant en cas de force majeure et dans les cas suivants, sans qu'ils aient à remplir les conditions de la force majeure : piratage informatique, privation, suppression, interdiction temporaire ou définitive, pour quelle que cause que ce soit (dont les pannes ou indisponibilités inhérentes au serveur d'hébergement ou de tout système d'information nécessaire à la transmission des Données), de l'accès au réseau Internet.
        </p>
        <p>
          Le Client et/ou l'Utilisateur est seul responsable de l'utilisation des Données ou de toutes autres informations issues de la Plateforme, ainsi que des conséquences éventuelles de cette utilisation.
        </p>
        <p>
          Le Client est seul responsable de la réalisation des opérations de fixation de prix et de l'exercice de toutes options éventuelles au titre du(des) Contrat(s) de vente d'énergie. En
        </p>
        <p>
          aucun cas la responsabilité d'ENGIE ne saurait être engagée en cas de perte financière par le Client liée à la réalisation (ou la non-réalisation) d'une ou plusieurs opération(s) de fixation de prix ou option(s) au titre du(des) Contrat(s) de vente d'énergie.
        </p>
        <p>
          Le Client demeurera seul responsable des actes et/ou opérations réalisées par ses Utilisateurs. Le Client et/ou l'Utilisateur est responsable de la confidentialité de son Identifiant et de son mot de passe lui permettant d'accéder à la Plateforme.
        </p>
        <p>
          Il appartient au Client et/ou l'Utilisateur de prendre toutes les mesures appropriées de façon à protéger ses matériels, données et logiciels de la contamination par d'éventuels virus circulant sur le réseau Internet. En aucun cas ENGIE ne pourra être tenue responsable des dommages quels qu'ils soient résultants de l'utilisation et de la consultation de la Plateforme.
        </p>
        <h6 style={{color: '#4F81BE'}}>9. Résiliation</h6>
        <p>
          La Plateforme est résiliable par le Client à tout moment directement en adressant par message électronique à l'Interlocuteur ENGIE un formulaire de demande de résiliation.
        </p>
        <p>
          En cas de non-utilisation de la Plateforme par le Client, ENGIE se réserve le droit de résilier la Plateforme sans formalités. Dans ce cas, le Client reçoit par courrier électronique un message l'informant de la résiliation à venir. Cette résiliation ne pourra donner lieu à aucune indemnité de quelle que nature que ce soit.
        </p>
        <p>
          En tout état de cause, la résiliation de la Plateforme n'entraîne pas la résiliation du ou des Contrats de vente d'énergie préalablement conclus par le Client.
        </p>
        <p>
          En cas de résiliation du ou des Contrat(s) de vente d'énergie pour quelle que cause que ce soit, la Plateforme sera automatiquement résiliée par ENGIE à compter de la date de résiliation du(des)dit(s) Contrats de vente d'énergie. Cette résiliation ne pourra donner lieu à aucune indemnité de quelque nature que ce soit.
        </p>
        <p>
          Si le Client n'est plus titulaire du Contrat de vente d'énergie pour quelle que raison que ce soit, il ne pourra plus visualiser ses Données et la Plateforme sera résiliée par ENGIE. Cette résiliation ne pourra donner lieu à aucune indemnité de quelque nature que ce soit.
        </p>
        <h6 style={{color: '#4F81BE'}}>10. Loi applicable et attribution de compétenc</h6>
        <p>
          Les Conditions Générales d'Utilisation de la Plateforme sont soumises au droit français. Tout litige lié à l'acceptation, l'exécution ou l'interprétation des Conditions Générales d'Utilisation de la Plateforme, qui n'aurait pu être réglé à l'amiable par les Parties, relèvera des tribunaux compétents.
        </p>
        <h6 style={{color: '#4F81BE'}}>11. Modification des Conditions Générales d'Utilisation de la Plateforme</h6>
        <p>Les modifications des Conditions Générales d'Utilisation de la Plateforme pourront être portées à la connaissance du Client par tout moyen. En l'absence d'opposition du Client aux nouvelles Conditions Générales d'Utilisation dans un délai d'un (1) mois, elles seront réputées acceptées et se substitueront de plein droit aux précédentes Conditions Générales d'Utilisation de la Plateforme. Le Client reconnaît avoir pris connaissance des Conditions Générales d'Utilisation de la Plateforme et déclare expressément les accepter sans réserve.</p>
      </ModalBody>
      <ModalFooter
        style={{
          textAlign: 'right',
          padding: '1rem 1.5rem',

        }}
      >
        <Button
          color="primary"
          onClick={onAccept}
          css={{
            backgroundColor: '#0072BC',
            borderColor: '#0072BC',
            fontWeight: 'bold',
          }}
        >
          Accepter
        </Button>
      </ModalFooter>
    </Modal>
  );
};
